"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AuthorisedPersonForm = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("../../helpers");
var _DefaultAuthorisedPersonDisplaySettings = require("./DefaultAuthorisedPersonDisplaySettings");
var _AuthorisedPersonPropTypes = require("./AuthorisedPersonPropTypes");
var _OwnerBirthdate = require("../../components/Forms/FormElements/SpecialInputs/Birthdates/OwnerBirthdate");
var _StyledRadios = require("../../components/Forms/FormElements/Radios/StyledRadios/StyledRadios");
var _InputText = require("../../components/Forms/FormElements/InputText");
var _FormUtils = require("../../utilities/FormUtils");
var _authorisedPersonFormDisplaySettingsPropTypes = require("../../propTypes/authorisedPersonFormDisplaySettingsPropTypes");
require("./authorisedPersonForm.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const AuthorisedPersonForm = _ref => {
  let {
    formContext,
    authorisedPersonDisplaySettings = _DefaultAuthorisedPersonDisplaySettings.DefaultAuthorisedPersonDisplaySettings,
    authorisedPersonDetails
  } = _ref;
  const showAuthorisedPersonForm = formContext && formContext.getValues('owner.hasAuthorisePerson') === true;
  const [isShowingForm, setIsShowingForm] = (0, _react.useState)(showAuthorisedPersonForm);
  const authorisedPerson = (0, _react.useMemo)(() => authorisedPersonDetails || _AuthorisedPersonPropTypes.emptyAuthorisedPersonDetails, [authorisedPersonDetails]);
  const {
    authorisedPersonPanelToggleRadios,
    authorisedPersonFirstNameInput,
    authorisedPersonLastNameInput,
    authorisedPersonBirthdateInput,
    readonlyMode
  } = authorisedPersonDisplaySettings;
  const readOnlyOverrides = () => {
    if (readonlyMode) {
      return {
        readOnly: true,
        validation: {},
        labelTooltip: null
      };
    }
    return {};
  };
  const handleRadioChange = value => {
    if (value !== 'yes') {
      formContext.setValue('owner.authorisedMemberFirstName', null);
      formContext.setValue('owner.authorisedMemberSurname', null);
      formContext.setValue('owner.authorisedMemberDob', null);
      setIsShowingForm(false);
    } else {
      setIsShowingForm(true);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "authorisedPersonForm"
  }, !readonlyMode && /*#__PURE__*/_react.default.createElement(_StyledRadios.StyledRadios, _extends({
    fieldFormContext: formContext,
    groupName: "owner.hasAuthorisePerson",
    name: "owner.hasAuthorisePerson",
    value: _FormUtils.formUtils.mapValueToYesNo(authorisedPerson.hasAuthorisePerson),
    onChange: handleRadioChange
  }, authorisedPersonPanelToggleRadios)), (readonlyMode || isShowingForm) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, "Authorised person"), /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    fieldFormContext: formContext,
    name: "owner.authorisedMemberFirstName",
    defaultValue: authorisedPerson.firstName
  }, authorisedPersonFirstNameInput, readOnlyOverrides())), /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    fieldFormContext: formContext,
    name: "owner.authorisedMemberSurname",
    defaultValue: authorisedPerson.lastName
  }, authorisedPersonLastNameInput, readOnlyOverrides())), /*#__PURE__*/_react.default.createElement(_OwnerBirthdate.OwnerBirthdate, _extends({
    fieldFormContext: formContext,
    name: "owner.authorisedMemberDob",
    defaultValue: (0, _helpers.IsValidDate)(authorisedPerson.birthdate) ? (0, _helpers.DateToShortIsoString)(new Date("".concat(authorisedPerson.birthdate))) : ''
  }, authorisedPersonBirthdateInput, readOnlyOverrides()))));
};
exports.AuthorisedPersonForm = AuthorisedPersonForm;
AuthorisedPersonForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes.default.any,
  authorisedPersonDisplaySettings: _propTypes.default.shape(_authorisedPersonFormDisplaySettingsPropTypes.AuthorisedPersonFormDisplaySettingsPropTypes),
  routeDispatcher: _propTypes.default.func,
  formId: _propTypes.default.string.isRequired,
  authorisedPersonDetails: _propTypes.default.shape(_AuthorisedPersonPropTypes.AuthorisedPersonDetailsPropType),
  globalDispatcher: _propTypes.default.func
};
var _default = exports.default = {
  AuthorisedPersonForm
};